import { AuthContext } from '../context/AuthContext';
import { useContext, useState } from 'react';
import { getFiadoProducts } from '../api/request'
import { getPaymentMethods } from '../api/request';
export const usePideFiado = () => {

  const { setLoading, permissions, setCart, cart,checkToken } = useContext(AuthContext);

  const addProduct = (productData, key) => {


    let product = {
      'exchangeRate': setExchageRateProduct,
      'fiadoProduct': setFiadoProduct, 
      'paymentMethod': setPaymentMethods
    }


    // const getPaymentMethod = async (currencyId) => {
    //     try {
    //       setLoading(true);
    //       const {data} = await getPaymentMethods(currencyId, "484",'PIDE_FIADO');
    //       let sort = sortItems(data.data[0].items)
    //       setLoading(false);
    //       return sort;
    //     } catch (e) {
    //       setLoading(false);
    //       console.log(e);
    //       return false;

    checkToken()
    try {
      product[key](productData);
    } catch (error) {
      console.log(error);
    }

    // let myCart = cart;
    // let keyExists = keyInArray(key)


    // if(keyExists){
    //  myCart.map((obj)=>{
    //       if(obj[`${key}`]){
    //         obj[`${key}`][`${key}`] = productData
    //       }
    //   });
    // }else{
    //     console.log(key);
    //     myCart.push({[`${key}`]:{id: productData}});    
    // }

    // setCart(myCart);
    // console.log(cart);

  }

  const keyInArray = (key) => {
    let keySearch = cart.filter(element => Object.keys(element).includes(key));
    if (keySearch.length > 0) {
      return true
    } else {
      return false;
    }
  }


  const getFiadoProduct = async (originCurrency, destinationCurrencyId) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getFiadoProducts(originCurrency, destinationCurrencyId)
      let sort = sortItems(data.data[0].items)
      setLoading(false);
      return sort
    } catch (e) {
      setLoading(false);
      return false
    }
  }

  const getPaymentMethod = async (originCurrency, destinationCurrencyId="484", component="PIDE_FIADO") => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getPaymentMethods(originCurrency, destinationCurrencyId, component);
      //console.log(data.data)
      if(data.data.length > 0 ){
        var sort = sortItems(data.data[0].items);
      }else{
        //console.log('no hay datos')
        setLoading(false);
        return false
      }

      //console.log(sort);
      setLoading(false);
      return sort;
    } catch (e) {
      setLoading(false);
      //console.log(e);
      return false;
    }
  }

  const sortItems = (items) => {
    let sort = items.sort((a, b) => {
      if (a.sortingPosition < b.sortingPosition) {
        return -1;
      }
      if (a.sortingPosition > b.sortingPosition) {
        return 1;
      }
    });
    return sort;
  }


  const activeSubscription = () => {
    let subscription = permissions.filter(element => element.name == 'FIADO_SUBSCRIPTIONS')[0];
    //Si existe  la condicion de suscripcion entonces valida si cuenta con una.
    if (subscription != undefined) {
      if (subscription.isTurnOn == true) {
        return false
      } else {
        return true;
      }
    } else {
      return false;
    }
  }


  const setExchageRateProduct = (exchangeData) => {

    let myCart = cart;
    let keyExists = keyInArray('exchangeRate');

    if (keyExists) {
      myCart.map((obj) => {
        if (obj.exchangeRate) {
          obj.exchangeRate = exchangeData
        }
      });

    } else {
      myCart.push({ exchangeRate: exchangeData });
      setCart(myCart);
    }

    //console.log(cart);
  }

  const setFiadoProduct = (productId) => {

    let myCart = cart;
    let keyExists = keyInArray('fiadoProduct');

    //console.log(productId)

    if (keyExists) {
      myCart.map((obj) => {
        if (obj.fiadoProduct) {
          obj.fiadoProduct.id = productId
        }
      });
    } else {
      myCart.push({ fiadoProduct: { id: productId } });
      setCart(myCart);
    }
    //console.log(cart);
  }

  const setPaymentMethods = (productId) => {

    let myCart = cart;
    let keyExists = keyInArray('paymentMethod');

    if (keyExists) {
      myCart.map((obj) => {
        if (obj.paymentMethod) {
          obj.paymentMethod.id = productId
        }
      });
    } else {
      myCart.push({ paymentMethod: { id: productId } });
      setCart(myCart);
    }

    //console.log(cart);
  }




  return {
    addProduct,
    keyInArray,
    getFiadoProduct,
    getPaymentMethod,
    sortItems,
    activeSubscription
  }

}